var items = [];
var itemsSelected = [];

/*

Envy by WeTheme (http://www.wetheme.com)
Custom JS

*/

// Responsive tables init

$(document).ready(function() {
  $('.product-description-wrapper table').wrap('<div class="rte__table-wrapper"></div>');
});

// Wow Animation init
$(document).ready(function() {
  new WOW().init();
});

// Mobile Browser Menu

$('select#mobile-menu').change(function() {
  window.location = $(this)
    .find('option:selected')
    .val();
});

// FancyBox

$(document).ready(function() {
  $('.fancybox').fancybox();
});

$(document).ready(function() {
  $('.fancybox-instagram').fancybox({
    padding: 0
  });
});

// Login Boxes

$('#forgot-password-box').click(function() {
  $('#customer-login').hide();
  $('#recover-password').show();
});

$('#login-box-link').click(function() {
  $('#customer-login').show();
  $('#recover-password').hide();
});

// Drawers

var MOBILE_DRAWER_SIZE = 300,
  DESKTOP_DRAWER_SIZE = 390,
  MOBILE_WIDTH_MAX = 768;

window.slideouts = {};

// Simulate responsiveness of the Drawer component
$(window).resize(function() {
  var is_mobile = document.body.clientWidth < MOBILE_WIDTH_MAX;

  // Disable mobile drawer on desktop
  //window.slideouts.left._touch = is_mobile;

  // Resize right drawer based on window width
  var slideout = window.slideouts.right,
    padding = is_mobile ? MOBILE_DRAWER_SIZE : DESKTOP_DRAWER_SIZE;
  slideout._translateTo = slideout._padding = padding * slideout._orientation;
  if (slideout._opened) {
    var transform = 'translateX(' + padding * slideout._orientation + 'px)';
    slideout.panel.style.webkitTransform = transform;
    slideout.panel.style.transform = transform;
  }
});

function create_drawer(side, panel, menu, hidden_menu, overlay) {
  var padding = MOBILE_DRAWER_SIZE;
  if (side === 'right' && document.body.clientWidth >= MOBILE_WIDTH_MAX) {
    padding = DESKTOP_DRAWER_SIZE;
  }

  var slideout = new Slideout({
    panel: panel,
    menu: menu,
    padding: padding,
    tolerance: 70,
    side: side,
    touch: false
  });
  var dir = side === 'right' ? -1 : 1;
  window.slideouts[side] = slideout;
  menu.classList.add('slideout-panel-hidden');

  var $overlay = $(overlay);
  overlay.addEventListener('click', slideout.close.bind(slideout));

  // Handle slide to close
  var touch_start = null;
  overlay.addEventListener('touchstart', function(event) {
    if (!slideout.isOpen()) {
      return;
    }
    event.preventDefault();
    touch_start = event.touches[0].pageX;
  });
  overlay.addEventListener('touchmove', function(event) {
    if (!slideout.isOpen()) {
      return;
    }
    var offset = touch_start - event.touches[0].pageX;
    var translate = dir * padding - offset;
    if (Math.abs(translate) > padding) {
      translate = dir * padding;
    }
    panel.style.webkitTransform = 'translateX(' + translate + 'px)';
    panel.style.transform = 'translateX(' + translate + 'px)';
  });
  overlay.addEventListener('touchend', function(event) {
    if (!slideout.isOpen()) {
      return;
    }
    var offset = touch_start - event.changedTouches[0].pageX;
    if (offset === 0 || Math.abs(offset) > 70) {
      slideout.close(slideout);
    } else {
      panel.style.webkitTransform = 'translateX(' + dir * padding + 'px)';
      panel.style.transform = 'translateX(' + dir * padding + 'px)';
    }
  });

  slideout.on('beforeopen', function() {
    menu.classList.remove('slideout-panel-hidden');
    //hidden_menu.classList.add('slideout-panel-hidden');
    $overlay.fadeIn();
    // document.body.style.overflowY = 'hidden';
    var marginTop = -document.body.scrollTop + 'px';
    panel.style.position = 'fixed';
    panel.style.marginTop = marginTop;
  });

  slideout.on('beforeclose', function() {
    $overlay.fadeOut();
    var scrollTop = -parseInt(panel.style.marginTop);
    panel.style.position = '';
    panel.style.marginTop = '';
    document.body.scrollTop = scrollTop;
  });

  slideout.on('close', function() {
    menu.classList.add('slideout-panel-hidden');
  });
  slideout.on('translate', function(translated) {
    var hidden = false;
    if (translated === 0) {
      hidden = true;
      //} else if (side === 'left') {
      //hidden = translated <= 0;
    } else if (side === 'right') {
      hidden = translated >= 0;
    }
    menu.classList.toggle('slideout-panel-hidden', hidden);
    //hidden_menu.classList.toggle('slideout-panel-hidden', !hidden);
  });

  return slideout;
}

function load_menu_drawer() {
  var main_body = document.querySelector('#main-body');
  var left_menu = undefined;
  var right_menu = document.querySelector('#cartSlideoutWrapper');
  var overlay = document.querySelector('#slideout-overlay');

  /* Cart */
  var slideoutRight = create_drawer('right', main_body, right_menu, left_menu, overlay);

  // Toggle button
  $('.slide-menu-cart').on('click', function(e) {
    slideoutRight.toggle();
    // prevent non-ajax basket
    e.preventDefault();
    return false;
  });

  $('.cart-menu-close').on('click', function(e) {
    slideoutRight.close();
  });

  // Add events for sidebar manipulation from outside
  $(right_menu)
    .on('cart:toggle', slideoutRight.toggle.bind(slideoutRight))
    .on('cart:open', slideoutRight.open.bind(slideoutRight))
    .on('cart:close', slideoutRight.close.bind(slideoutRight));
}

$(document).ready(load_menu_drawer);
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId === 'header') {
    load_menu_drawer();
  } else if (event.detail.sectionId === 'footer') {
    // Shopify doesn't correctly handle scrolling to footer on section change because the section
    // has zero height when it's scrolled to but when it loads it gets out of visible area
    setTimeout(function() {
      // Scroll to the footer element after loading
      document.documentElement.scrollTop = document.body.scrollTop = document.body.clientHeight;
    }, 0);
  }
});

$(document).ready(function() {
  $('.side-menu .accordion-head').click(function() {
    var sideMenuAccordions = $('.side-menu .accordion-head').not(this);
    for (var i = 0; i < sideMenuAccordions.length; i++) {
      var container = $(sideMenuAccordions[i]).closest('.accordion');
      container.find('.accordion-body').slideUp();
      $(sideMenuAccordions[i])
        .find('i.fa')
        .removeClass('invert');
    }
  });

  $('.accordion-head').click(function() {
    var container = $(this).closest('.accordion');
    container.find('.accordion-body').slideToggle();
    $(this)
      .find('i.fa')
      .toggleClass('invert');
  });

  var $window = $(window);

  //make stockists navbar sticky on scroll
  if ($('#sticky-nav').length > 0) {
    var $stickyNav = $('#sticky-nav');
    var $stockistsColumn = $('#stockists-col');
    var stockistTop = $stickyNav.offset().top;
    var $footer = $('#footer-id');

    function stickyRelocate() {
      var stockistWidth = $stockistsColumn.width() + 'px';
      var windowTop = $window.scrollTop();
      var stickyNavHeight = $stickyNav.outerHeight();
      var navBottom = windowTop + stickyNavHeight;
      var footerTop = $footer.offset().top;

      if (windowTop >= stockistTop) {
        $stickyNav.addClass('stick-stockists');
        $stickyNav.css('width', stockistWidth);
        $('#main-body').removeClass('slideout-panel');
        if (navBottom >= footerTop) {
          var coordinate = -(stickyNavHeight - (footerTop - windowTop)) + 'px';
          $stickyNav.css({ top: coordinate });
        } else {
          $stickyNav.css({ top: '0' });
        }
      } else {
        $stickyNav.removeClass('stick-stockists');
        $stickyNav.css('width', 'auto');
        $('#main-body').addClass('slideout-panel');
      }
    }

    stickyRelocate();
    $window.on('scroll', function() {
      stickyRelocate();
    });
    $window.on('resize', function() {
      stickyRelocate();
    });
    $window.on('orientationchange', function() {
      stickyRelocate();
    });
  } else {
    return;
  }
});

//logic for popups after page load
$(document).ready(function() {
  setTimeout(function() {
    var joinUsModal = $('#join-us-popup');

    if (joinUsModal.length != 0) {
      var joinUsPopup = checkShowPopup(joinUsModal, 'joinUsPopup');
    }

    $(window).onload = setTimeout(joinUsPopup, 10000);
  }, 10000);
});

function setModalCookie(cookieName, cookieValue, exdays) {
  var date = new Date();
  date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + date.toUTCString();
  document.cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/';
}

function getModalCookie(cookieName) {
  var name = cookieName + '=';
  var cookieArray = decodeURIComponent(document.cookie).split(';');
  for (var i = 0; i < cookieArray.length; i++) {
    var c = cookieArray[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function checkShowPopup(modalElement, storageItem) {
  if (localStorage.getItem(storageItem) !== 'closed' && getModalCookie(storageItem) !== 'click-through') {
    showPopup(modalElement, storageItem);
  } else {
    return;
  }
}

function showPopup(modalElement, storageItem) {
  var inputElement = modalElement.find('input[type=email]').not('[data-ignore]');
  var submitBtnElement = modalElement.find('.form-submit').not('[data-ignore]');
  modalElement.modal('show');
  checkInputValid(inputElement, submitBtnElement, storageItem);
  modalElement.on('hidden.bs.modal', function(e) {
    localStorage.setItem(storageItem, 'closed');
  });
}

function checkInputValid(input, submitBtn, cookieName) {
  var validationRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  submitBtn.on('click', function(event) {
    if (validationRegExp.test(input.val())) {
      setModalCookie(cookieName, 'click-through', 365);
      return;
    } else {
      event.preventDefault();
      input.addClass('error');
      $('.error-message').removeClass('hidden');
      return false;
    }
  });
  input.on('keydown', function() {
    input.removeClass('error');
    $('.error-message').addClass('hidden');
  });
}

$(document).ready(function() {
  $('.mobile-menu--wrapper.slideout-menu').css({ top: $('#shopify-section-announcement-bar').height() });

  $('a[href="#menu"]').click(function() {
    $('nav#sideMenu').slideToggle();
    $('.hamburger-icon').toggleClass('close');
  });
});

function fixFilters() {
  var collectionSidebar = $('#collection-sidebar');
  if (!$(collectionSidebar).hasClass('fixed-filters')) {
    $(collectionSidebar)
      .addClass('fixed-filters')
      .detach();
    $('body').append(collectionSidebar);
    $('[data-filter-spacer]').slideDown();
  }
}

function unfixFilters() {
  var collectionSidebar = $('#collection-sidebar');
  if ($(collectionSidebar).hasClass('fixed-filters')) {
    $(collectionSidebar)
      .removeClass('fixed-filters')
      .detach();
    $('.collection-display').prepend(collectionSidebar);
    $('[data-filter-spacer]').slideUp();
  }
}

$(document).scroll(function() {
  if ($('.collection-display').length > 0) {
    evalFixFilters();
  }
});

$(window).resize(function() {
  if ($('.collection-display').length > 0) {
    evalFixFilters();
  }
});

function evalFixFilters() {
  windowWidth = window.innerWidth ? window.innerWidth : $(window).width();

  if (windowWidth > 767) {
    var docScrollTop = $(window).scrollTop();
    var docScrollBottom = $(window).scrollTop() + $(window).height();
    console.log(docScrollTop);
    var collectionScroll = $('.collection-display').offset().top;
    console.log(collectionScroll);
    var footerScroll = $('#footer-id').offset().top;
    console.log(footerScroll);
    if (docScrollTop > collectionScroll && docScrollBottom < footerScroll + 100) {
      fixFilters();
    } else {
      unfixFilters();
    }
  } else {
    unfixFilters();
  }
}

// Product page thumb arrows
$(document).ready(function() {
  var $thumbsHolder = $('.product-page--side-thumbnails');
  var $thumbsList = $('#product-thumbnails');
  var $thumbsScroller = $('.product-page--side-thumbnails > .row');
  var scrollStep = $thumbsList.find('li:eq(0)').height() + 5;
  var $arrows = $('.arrow-span');
  var $arrowUp = $arrows.find('#up');
  var $arrowDown = $arrows.find('#down');

  if ($thumbsHolder.height() < $thumbsList.height()) {
    $arrows.show();
  }

  $arrowUp.on('click', function() {
    $thumbsScroller.animate({
      scrollTop: $thumbsScroller.scrollTop() - scrollStep
    });
  });

  $arrowDown.on('click', function() {
    $thumbsScroller.animate({
      scrollTop: $thumbsScroller.scrollTop() + scrollStep
    });
  });
});

// low stock alert

$(document).ready(function() {
  var $select = $('#ProductSelect-product-template');
  var $lowstockAlert = $('.lowstock-alert');
  var lowStockNumber = $select.data('lowstock');

  $select.on('change', function() {
    var productInventory = $(this)
      .find('option:selected')
      .data('inventory');

    if (productInventory <= 0) {
      $lowstockAlert.removeClass('active');
    } else if (lowStockNumber > productInventory) {
      $lowstockAlert.addClass('active');
    } else {
      $lowstockAlert.removeClass('active');
    }
  });
});

$(document).ready(function() {
  // Collection Filter

  $('.collection-filter-bar .has-sub-link > a').on('click', function(event) {
    event.preventDefault();

    var $this = $(this);

    $this
      .next('ul')
      .slideToggle()
      .closest('li')
      .toggleClass('opened')
      .siblings('.has-sub-link')
      .removeClass('opened')
      .find('ul')
      .slideUp();
  });

  $('.collection-sidebar .show-filters').on('click', function(event) {
    event.preventDefault();

    var $this = $(this);

    $this
      .toggleClass('opened')
      .next('.collection-filter-bar')
      .slideToggle();
  });

  $('.open-accordion').on('click', function(event) {
    event.preventDefault();

    var $this = $(this);

    $this
      .closest('h3')
      .toggleClass('opened')
      .closest('.widget')
      .find('>ul')
      .slideToggle();
  });

  // Collection products sizes

  $(document).on('change', '.collection-products .list-sizes input', function() {
    var $this = $(this);
    var $form = $this.closest('form');
    var $hiddenInput = $form.find('input[name="id"]');
    var value = $this.attr('id');

    $hiddenInput.val(value);

    $form.trigger('submit');
  });

  $(document).on('submit', '.collection-products .indiv-product form', function(event) {
    event.preventDefault();

    var $form = $(this);

    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      dataType: 'json',
      data: $form.serialize()
    })
      .done(function() {
        $.ajax({
          url: '/cart/update.js',
          type: 'post',
          dataType: 'json'
        }).done(function(data) {
          $('.cart-item-count,.cart-item-count-header').text(data.item_count);
          $('.cart-item-price').html(formatMoney(data.total_price));
          Currency.convertAll(Currency.shopCurrency, jQuery('[name=currencies]').val());
          $('#cartSlideoutWrapper').trigger('cart:open');
        });
      })
      .fail(function(error) {
        alert(error.responseJSON.description);
      });
  });

  // Disable unavailable sizes

  $('.collection-products .list-sizes li').each(function() {

    var $this = $(this);
    var $input = $this.find('input');
    var $hiddenSelect = $this.closest('form').find('.product-single__variants');
    var inputValue = $input.data('value');
    var isSizeAvailable = $hiddenSelect.find('option[data-size="' + inputValue + '"]').prop('disabled');

    $input.prop('disabled', isSizeAvailable);
  });

  // Change collection products layout

  $('.collection-change-layout input[type="radio"]').on('change', function() {
    var $this = $(this);

    $.ajax({
      url: '/cart/update.js',
      type: 'POST',
      dataType: 'JSON',
      data: 'attributes[collection-products-per-row]=' + $this.val()
    }).done(function(data) {
      window.location.reload();
    });
  });

  // Collection Filtration

  if ($('.js-collection-filter').length) {
    var allTags = $('.js-collection-filter')
      .data('current_tags')
      .split(',');

    for (var i = 0; i < allTags.length; i++) {
      $('.js-collection-filter input[data-value="' + allTags[i] + '"]')
        .attr('checked', 'checked')
        .trigger('change');
    }

    $('.js-collection-filter input').on('change', function(event) {
      event.preventDefault();

      var tagsSelector = '';
      var collectionUrl = $('.js-collection-filter').data('collection_url');

      $('.js-collection-filter input:checked').each(function() {
        tagsSelector += $(this).data('value') + '+';
      });

      window.location.href = collectionUrl + '/' + tagsSelector;
    });
  }

  // Change collection view (Models/products)

  $('.collection-change-layout select').on('change', function() {
    var $this = $(this);

    $.ajax({
      url: '/cart/update.js',
      type: 'POST',
      dataType: 'JSON',
      data: 'attributes[collection-view]=' + $this.val()
    }).done(function(data) {
      window.location.reload();
    });
  });

  var $productSelect = $('.product-form__variants');

  $('.product-variants input[type="radio"]').on('change', function() {

    var $this = $(this);
    var $checkedInputs = $this.closest('.product-variants').find('input[type="radio"]:checked');
    var $addTocartButton = $this.closest('form').find('#purchase');
    var $selectedOption;
    var $priceHolder = $this.closest('form').find('.custom-font.js.sale-price');
    var price = '';
    var selector = '';

    $checkedInputs.each(function() {
      var $input = $(this);
      var option = $input.closest('.product-variant').data('option');
      var value = $input.val();

      selector += '[data-' + option + '="' + value + '"]';
    });

    $selectedOption = $productSelect.find('option' + selector);
    $selectedOption.prop('selected', true).trigger('change');
    $addTocartButton.prop('disabled', $selectedOption.prop('disabled'));

    price = $selectedOption.data('price');
    $priceHolder.text(price);

    var variantId = $selectedOption.prop('selected', true).val();
    var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variantId;

    window.history.replaceState({ path: newurl }, '', newurl);
  });

  // LOAD PRODUCT VARIANT
  $('.product-variant').each(function() {
    var $this = $(this);
    var option = $this.data('option');
    var selector = '';
    var $inputs = $this.find('.list-variants li');

    $inputs.each(function() {
      var $input = $(this).find('input[type="radio"]');
      var value = $input.val();

      selector = '[data-' + option + '="' + value + '"]';

      var $selectOption = $productSelect.find('option' + selector);

      if ($selectOption.data('inventory') > 0) {
        $input.addClass('in-stock');
      } else {
        $input.addClass('sold-out');
      }

    });
  });

  // VARIANT CHANGE
  $('.list-variants input[type="radio"]').change(function(){
      toggleSoldOutInStock();
  });

  function toggleSoldOutInStock() {

      var checkme = $('.product-form__variants').find(':selected').data('available');

      if(checkme == false) {
        $('#product-out-of-stock-notification').removeClass('hidden');
        $('.product-actions').addClass('hidden');
        $('.info-links').addClass('hidden');
        $('.shipping-info').addClass('hidden');
        $('.product-description').addClass('hidden');
      } else {
        $('#product-out-of-stock-notification').addClass('hidden');
        $('.product-actions').removeClass('hidden');
        $('.info-links').removeClass('hidden');
        $('.shipping-info').removeClass('hidden');
        $('.product-description').removeClass('hidden');
      }
  }

  // Product tabs

  $('.product-tabs .tabs__nav a').on('click', function(event) {
    event.preventDefault();
    var $this = $(this);

    $this
      .closest('li')
      .addClass('active')
      .siblings()
      .removeClass('active');

    $($this.attr('href'))
      .addClass('active')
      .siblings()
      .removeClass('active');
  });

  $('.more-info-trigger').on('click', function(event) {
    event.preventDefault();

    $('.product-more-info').toggleClass('hidden');
  });

  // Blog tags on mobile

  $('.blog-tags--mobile select').on('change', function() {
    var $this = $(this);
    var blogUrl = $this.closest('select').data('blog_url');
    var filteredUrl = blogUrl + '/tagged/' + $this.val();

    window.location.href = filteredUrl;
  });

  // Select the node that will be observed for mutations
  var $targetNode = $('.collection-holder');

  // Options for the observer (which mutations to observe)
  var config = { childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  var callback = function(mutationsList) {
    setTimeout(function() {
      var $sidebar = $('.bc-sf-filter-selection-wrapper');

      if (!$sidebar.hasClass('updated') && !$('#bc-sf-filter-options-wrapper').hasClass('updated')) {
        $sidebar.addClass('updated');
        $('#bc-sf-filter-options-wrapper').addClass('updated');

        if (Currency.cookie.read() == null) {
          if (jQuery('[name=currencies]').length) {
            Currency.convertAll(Currency.shopCurrency, jQuery('[name=currencies]').val());
          } else {
            Currency.convertAll(Currency.shopCurrency, Currency.shopCurrency);
          }
        } else {
          Currency.convertAll(Currency.shopCurrency, Currency.cookie.read());
        }

        // updateFilter();
        items = [];
        itemsSelected = [];
        populateObjectPrices();
        convertAllItems(items, itemsSelected);
      }
    }, 100);
  };

  // Create an observer instance linked to the callback function
  var observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  if ($targetNode.length) {
    observer.observe($targetNode[0], config);
  }
});

// function updateFilter() {
//   if ($(".selected-item.bc-sf-filter-option-label").length) {
//     $(".selected-item.bc-sf-filter-option-label").each(function() {
//       var $label = $(this);

//       if ($label.text().indexOf("Price:") != -1) {
//         var priceArray = $(".bc-sf-filter-option-label .selected-type strong").text().split("-");
//         var updatedLabelPriceMin = convertPrice(priceArray[0]);
//         var updatedLabelPriceMax = convertPrice(priceArray[1]);
//         var updatedLabelPrice = "";

//         updatedLabelPriceMin = Shopify.formatMoney(updatedLabelPriceMin, decodeHtml(Currency.moneyFormats[Currency.currentCurrency].money_format));

//         updatedLabelPriceMax = Shopify.formatMoney(updatedLabelPriceMax, decodeHtml(Currency.moneyFormats[Currency.currentCurrency].money_format));

//         updatedLabelPrice = updatedLabelPriceMin + " - " + updatedLabelPriceMax;

//         $label.find("strong").html(updatedLabelPrice);
//       }
//     });
//   }

//   if ($(".bc-sf-filter-option-block-range .bc-sf-filter-block-title").length) {
//     var $span = $(".bc-sf-filter-option-block-range .bc-sf-filter-block-title span");
//     var spanText = $span.text().split("(")[0];

//     var currentCurrencySymbol = Currency.moneyFormats[Currency.currentCurrency].money_format
//       .replace("{{amount}}", "")
//       .replace("{{amount_no_decimals}}", "");

//     spanText = spanText + " (" + currentCurrencySymbol + ")";
//     $span.html(spanText);
//   }

//   if ($("#bc-sf-filter-option-range-slider-pf_p_price").length) {
//     var priceArray = $("#bc-sf-filter-option-range-slider-pf_p_price").data("value").split(":");

//     $("#bc-sf-filter-option-range-slider-pf_p_price").find(".noUi-value").each(function() {
//       var $this = $(this);
//       var currentPrice = parseFloat($this.text());

//       $this.text(parseInt(convertPrice(currentPrice)));
//     });
//   }
// }

function populateObjectPrices() {
  if (items.length === 0) {
    $('.noUi-value').each(function() {
      var $this = $(this);
      var obj = {};
      obj.el = $this;
      obj.price = [$this.text()];
      items.push(obj);
    });
  }
  itemsSelected = [];
  $('.bc-sf-filter-selected-items .selected-item').each(function() {
    var $this = $(this);
    if (
      $this
        .find('.selected-type > span')
        .text()
        .trim() == 'Price'
    ) {
      var obj = {};
      var $strongTextArray = $this
        .find('strong')
        .text()
        .split('-');
      obj.el = $this.find('strong');
      obj.price = [];
      $strongTextArray.map(function(item) {
        var textValue = item.trim().replace(/[^\d.]/g, '');
        var price = textValue.replace('/^./g', '');
        obj.price.push(price);
      });
      itemsSelected.push(obj);
    }
  });
}

function convertAllItems(itemsToConvert, itemsSelected) {
  itemsToConvert.map(function(item) {
    var newPrice = item.price.map(function(price) {
      item.el.text(parseInt(Currency.convert(parseInt(price), Currency.shopCurrency, Currency.currentCurrency)));
    });
  });

  itemsSelected.map(function(itemSlected) {
    var priceArray = [];
    itemSlected.price.map(function(price) {
      var format = Currency.moneyFormats[Currency.currentCurrency].money_format;
      var convertedPrice = Currency.convert(parseFloat(price), Currency.shopCurrency, Currency.currentCurrency).toFixed(2);
      var finalPriceText = format.replace('{{amount}}', convertedPrice).replace('{{amount_no_decimals}}', convertedPrice);
      priceArray.push(finalPriceText);
    });
    var joinedPrice = priceArray.join(' - ');
    itemSlected.el.html(joinedPrice);
  });

  var getFormat = Currency.moneyFormats[Currency.currentCurrency].money_format
    .replace('{{amount}}', '')
    .replace('{{amount_no_decimals}}', '')
    .trim();

  $('.bc-sf-filter-option-block-range .bc-sf-filter-block-title h3 span').html('Price:(' + getFormat + ')');
}

$(document).on('customchange', '.currency-picker', function() {
  Currency.convertAll(Currency.shopCurrency, Currency.cookie.read());
  convertAllItems(items, itemsSelected);
});

$(document).on('click', '.video-popup a', function(event) {
  event.preventDefault();

  $.magnificPopup.open({
    items: {
      src: $(this).attr('href')
    },
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });
});

$(document).on('click', '.bc-sf-filter-block-title h3', function() {
  $(this).toggleClass('opened');
});

$(window).on('load', function() {
  // oldCurrency.push(Currency.currentCurrency);
  // Currency.convertAll(Currency.shopCurrency, Currency.cookie.read());
  // updateFilter();
});

if (isTouchDevice()) {
  $(document).on('click', '.additional-nav.has-dropdown a', function(event) {
    var $this = $(this);

    if (!$this.hasClass('clicked')) {
      event.preventDefault();
      $this.addClass('clicked');
    }
  });
}

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

function decodeHtml(html) {
  var txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

// function convertPrice(item) {
//   var itemPrice = item.toString().match(/[0-9]+/g).join("");
//   if (item.toString().match(/\./)) {
//     itemPrice = parseInt(itemPrice) / 100;
//   }
//   if (oldCurrency.length > 1) {
//     var convertPrice = Currency.convert(parseFloat(itemPrice), oldCurrency[oldCurrency.length - 2], oldCurrency[oldCurrency.length - 1]).toFixed(2);
//   } else {
//     var convertPrice = Currency.convert(parseFloat(itemPrice), Currency.shopCurrency, Currency.cookie.read()).toFixed(2);
//   }

//   return convertPrice;
// }
